export const normalizeDineType = (value) => {
  const parsedValue = Number(value);

  if (parsedValue === 3 || parsedValue === 4) {
    return parsedValue;
  }

  return null;
};

export const resolveDineTypeSelection = ({
  availableDineType,
  storedDineType,
  fallbackDineType = 4,
}) => {
  const normalizedAvailableDineType = Number(availableDineType);
  const normalizedStoredDineType = normalizeDineType(storedDineType);
  const normalizedFallbackDineType = normalizeDineType(fallbackDineType) || 4;

  const deliveryOnly = normalizedAvailableDineType === 4;
  const pickupOnly = normalizedAvailableDineType === 3;

  let selectedDineType = normalizedFallbackDineType;

  if (deliveryOnly) {
    selectedDineType = 4;
  } else if (pickupOnly) {
    selectedDineType = 3;
  } else if (normalizedStoredDineType !== null) {
    selectedDineType = normalizedStoredDineType;
  }

  return {
    selectedDineType,
    activeIndex: selectedDineType === 4 ? 0 : 1,
    deliveryDisabled: pickupOnly,
    takeawayDisabled: deliveryOnly,
  };
};

export const getQrTableNumber = (entryMode, tableNo) => {
  if (String(entryMode || "").toUpperCase() !== "QR") {
    return "";
  }

  const normalizedTableNo = String(tableNo || "").trim();

  if (normalizedTableNo === "" || normalizedTableNo === "0") {
    return "";
  }

  return normalizedTableNo;
};

export const getOrderDineType = ({ dineType, tableNo }) => {
  const normalizedTableNo = String(tableNo || "").trim();

  if (normalizedTableNo !== "" && normalizedTableNo !== "0") {
    return 1;
  }

  return parseInt(dineType, 10);
};

export const getEffectiveDineType = ({
  dineType,
  csp,
  entryMode,
  tableNo,
}) => {
  const normalizedCsp = String(csp || "")
    .trim()
    .toUpperCase();
  const normalizedEntryMode = String(entryMode || "")
    .trim()
    .toUpperCase();
  const normalizedTableNo = String(tableNo || "").trim();

  if (
    normalizedCsp === "DT" &&
    normalizedEntryMode === "QR" &&
    normalizedTableNo !== "" &&
    normalizedTableNo !== "0"
  ) {
    return 1;
  }

  return parseInt(dineType, 10);
};
